/*! @pentacode/ui v0.1.0 */
//#region ../../node_modules/.pnpm/@oddsquad+vite-plugin-lit@0.18.0_@devframes+agentic@1.1.0_@vitejs+devtools-kit@0.7.6_@d_f933b84ccbcee89320ba752553fd70cb/node_modules/@oddsquad/vite-plugin-lit/lib/runtime/css-build.js
var e = (e, t) => {
	let n = new CSSStyleSheet();
	return n.replaceSync(e), t?.(n)(), n;
};
//#endregion
export { e as t };

//# sourceMappingURL=css-build-DICbZE45.js.map